import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IPartner } from "../../utils/types/models";

export default createEntityReducer<IPartner>(Endpoint.Partners, Endpoint.PartnersList);
